import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

interface Dates {
  period: number | undefined
  fromDate: string | undefined
  toDate: string | undefined
}

interface State {
  selectedEcommerce?: string
  selectedGroup?: string
  disableSelector: boolean
  drawerOpen: boolean
  datesDashboard: Dates
  datesAnalytics: Dates
}

const getEcommerceParam = () => {
  const urlParams = new URLSearchParams(window.location.search)

  return urlParams.get('ecommerceId')
}

const initialEcommerce =
  getEcommerceParam() || localStorage.getItem('selectedEcommerce') || undefined

const initialState: State = {
  selectedEcommerce: initialEcommerce,
  selectedGroup: initialEcommerce
    ? undefined
    : localStorage.getItem('selectedGroup') || undefined,
  disableSelector: false,
  drawerOpen: window.innerWidth >= 900,
  datesDashboard: {
    period: undefined,
    fromDate: undefined,
    toDate: undefined
  },
  datesAnalytics: {
    period: 2,
    fromDate: moment().subtract(1, 'M').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD')
  }
}

const generalDataSlice = createSlice({
  name: 'generalData',
  initialState,
  reducers: {
    toggleDisabledSelector(state) {
      state.disableSelector = !state.disableSelector
    },
    setSelectedEcommerce(state, action) {
      if (action.payload)
        localStorage.setItem('selectedEcommerce', action.payload)
      else localStorage.removeItem('selectedEcommerce')
      localStorage.removeItem('selectedGroup')
      state.selectedEcommerce = action.payload
      state.selectedGroup = undefined
    },
    setSelectedGroup(state, action) {
      if (action.payload) localStorage.setItem('selectedGroup', action.payload)
      else localStorage.removeItem('selectedGroup')
      localStorage.removeItem('selectedEcommerce')
      state.selectedGroup = action.payload
      state.selectedEcommerce = undefined
    },
    toggleDrawer(state) {
      state.drawerOpen = !state.drawerOpen
    },
    setDatesDashboard(state, action) {
      state.datesDashboard.period = action.payload.period
      state.datesDashboard.fromDate = action.payload.fromDate
      state.datesDashboard.toDate = action.payload.toDate
    },
    setDatesAnalytics(state, action) {
      state.datesAnalytics.period = action.payload.period
      state.datesAnalytics.fromDate = action.payload.fromDate
      state.datesAnalytics.toDate = action.payload.toDate
    }
  }
})

export const {
  toggleDisabledSelector,
  setSelectedEcommerce,
  setSelectedGroup,
  toggleDrawer,
  setDatesDashboard,
  setDatesAnalytics
} = generalDataSlice.actions
export default generalDataSlice.reducer
